import { UserName } from '@festina-life/components'
import { useTranslate } from '@festina-life/ui/hooks'

import type { ConciseChangesetWithBranchKey } from '../../../../uiModels/changesets/types'

type Props = {
  changeset: ConciseChangesetWithBranchKey
}

export const ChangesetAuthor = ({ changeset }: Props) => {
  const translate = useTranslate()

  return (
    <div className="flex items-center gap-x-2">
      {changeset.creatorUserId ? (
        <UserName userId={changeset.creatorUserId} showIcon={false} />
      ) : (
        translate('changesetList.changeset.author.unknown')
      )}
    </div>
  )
}
